export default __webpack_public_path__ + "static/media/Ubuntu-Medium.c1e5c21a.ttf";